import './analyzers.scss';
import { ToolbarSimple } from '../../components';
import InfoAnalyzers from '../../components/library/info-analyzers/infoAnalyzers';
import { useState, useCallback, memo } from 'react';
import { SysI_Analizadores } from '../../types/types.analizadores';
import ModalTracerByAnalyzer from '../../components/library/info-analyzers/Modals/ModalTracerByAnalyzer';

// Componente separado para el panel izquierdo que no se re-renderiza
const AnalyzerDetailPanel = memo<{ selectedAnalyzer: SysI_Analizadores | undefined }>(({ selectedAnalyzer }) => {
  if (!selectedAnalyzer) {
    return null;
  }

  return (
    <div>
      <h4>{selectedAnalyzer.Az_Nombre}</h4>
      <ModalTracerByAnalyzer analyzer={selectedAnalyzer} orientation='vertical' />
    </div>
  );
});

const Index = () => {
  const [selectedAnalyzer, setSelectedAnalyzer] = useState<SysI_Analizadores | undefined>(undefined);

  const handleAnalyzerClick = useCallback((analyzer: SysI_Analizadores) => {
    setSelectedAnalyzer(analyzer);
  }, []);  
  
  return (
    <div className='view-wrapper-fixed'>
      <ToolbarSimple title='Analizadores'>
        <div className='split-container'>
          <div className='right-pane'>
            <InfoAnalyzers orientation='vertical' handleClick={handleAnalyzerClick} />
          </div>          
          <div className='left-pane'>
            <AnalyzerDetailPanel selectedAnalyzer={selectedAnalyzer} />
          </div>
        </div>
      </ToolbarSimple>
    </div>
  );
};

export default Index;
